import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import { connect } from 'react-redux';
import action from '@flux/action';
import { setSessionStorage, getSessionStorage } from '@utils/windowUtil';
// import PropTypes from 'prop-types';

function CreateResult({
  saveCreateProjectData,
  clearCompanyName,
  data: { companyData },
}) {
  const Successbtn = () => {
    const history = useHistory();
    const newProjectId = getSessionStorage('newProjectId').toUpperCase();
    const hasAuth = getSessionStorage('hasAuth') === 'true' ? true : false;

    const push2Detail = () => {
      if (newProjectId && hasAuth) {
        const projectName = getSessionStorage('newProjectName');
        setSessionStorage('projectName', projectName);

        window.SessionStorage.removeItem('newProjectName');
        window.SessionStorage.removeItem('newProjectId');
        history.push(`/project-detail/${newProjectId}`);
      } else {
        history.push(`/projects/list`);
      }
    };
    useEffect(() => () => {
      clearCompanyName();
      saveCreateProjectData({
        currentNum: 1, // 进度条，  第一步里的小步
        lastNum: 1, // create-project里面的，判断上次的位置
        currentStep: 1, // 进度条当前的步数
        isEditing: true,
      });
    });
    return (
      <div className="form-actions-horizon">
        <Button className="btn" size="xl" onClick={push2Detail}>
          {hasAuth ? `go to project home` : `go to project list`}
        </Button>
        {/* <Button className="btn" kind="secondary" size="xl">
          go to project settings
        </Button> */}
      </div>
    );
  };
  const {
    isSingleCompany,
    buyer: {
      companyName: buyerName,
      financialDateRange: buyerYear,
      sentimentAnalysisReviews: buyerReview,
    },
    target: {
      companyName: targetName,
      financialDateRange: targetYear,
      sentimentAnalysisReviews: targetReview,
    },
  } = companyData;
  return (
    <React.Fragment>
      <div className="create-project-result">
        <div className="project-form-result">
          <span className="appkiticon icon-circle-checkmark-outline success-icon" />
          Your project has been successfully created! Over the next 24 hours,
          your data will be reviewed and automatically updated for quality.
        </div>
        <div>
          {/*<span className="appkiticon icon-alert-fill alert-icon" />*/}
          <span className="disclaimer">Disclaimer</span>
          <p>
            In the instance you can’t find a company, please report the missing
            company using the “Report issue” feature.
          </p>
          <p>
            Note: Data provided may not always reflect the latest available data
            released by the company. The data is provided from third party
            providers (Craft.co, Dow Jones) and the quality of data is
            contingent on what they provide.
          </p>
        </div>
        <div className="project-form-result-table">
          <div className="first-row">
            <div>&nbsp;</div>
            <div>{buyerName}</div>
            {!isSingleCompany && <div>{targetName}</div>}
          </div>
          <div className="sec-row">
            <b>Financial data for </b>
            <div>{buyerYear}</div>
            {!isSingleCompany && <div>{targetYear}</div>}
          </div>
          <div className="third-row">
            <b>Sentiment Analysis</b>
            <div>
              {' '}
              {buyerReview && buyerReview >= 50 ? (
                <span className="appkiticon icon-check-mark-fill check-icon" />
              ) : (
                <span className="appkiticon icon-close-fill check-icon" />
              )}
            </div>
            <div>
              {targetReview && targetReview >= 50 ? (
                <span className="appkiticon icon-check-mark-fill check-icon" />
              ) : (
                <>
                  {' '}
                  {!isSingleCompany && (
                    <span className="appkiticon icon-close-fill check-icon" />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="project-form-divider" />
      <Successbtn />
    </React.Fragment>
  );
}
const mapStateToProps = ({ projects }) => ({ data: projects.saveData });

const mapDispatchToProps = (dispatch) => ({
  saveCreateProjectData(data) {
    dispatch(action.saveData(data));
  },
  clearCompanyName() {
    dispatch(action.clearCompanyName());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateResult);
